import { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";

export function useCartAddPulse() {
  const { lastAddedFeedback } = useCart();
  const [isPulsing, setIsPulsing] = useState(false);

  useEffect(() => {
    if (!lastAddedFeedback) return;
    setIsPulsing(true);
    const timer = window.setTimeout(() => setIsPulsing(false), 650);
    return () => window.clearTimeout(timer);
  }, [lastAddedFeedback?.token]);

  return isPulsing;
}
